import { useGroupAmends } from "authoring/routes/project/group/lib/use-group-amends"
import { canOpenAddGroupAmends } from "./add-group-amends"

export function useAddGroupAmends({ projectId, groupId, newTasks } = {}) {
    const { amends, saveAmend, deleteAmend } = useGroupAmends({ projectId, groupId })

    return {
        amends,
        saveAmend,
        deleteAmend,
        options: {
            canOpen: canOpenTaskAmends,
        },
    }

    function canOpenTaskAmends(amendsStateForKey) {
        return canOpenAddGroupAmends({
            amendsKey: amendsStateForKey?.amendsKey,
            newTasks,
        })
    }
}
